import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import loadingReducer from './slice/loadingSlice';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
export const history = createBrowserHistory();
const reducer = combineReducers({
  loading: loadingReducer,
  router: connectRouter(history),
});
export const store = configureStore({
  reducer,
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware().concat(routerMiddleware(history));
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
